// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6248":"c57a3b78","6966":"58279727","8333":"58279727"}[chunkId] + ".chunk.css";
};